import React from "react"
import PropTypes from "prop-types"
import ReactTooltip from "react-tooltip"
import EndOfBodyPortal from "../layout/EndOfBodyPortal"

function Tooltip({ id }) {
  return (
    <EndOfBodyPortal>
      <ReactTooltip id={id} effect="solid" className="filter-tooltip" />
    </EndOfBodyPortal>
  )
}

Tooltip.propTypes = {
  id: PropTypes.string.isRequired, // the id tying together this tooltip instance and the element it hooks into for target and content
}

export default Tooltip



// WEBPACK FOOTER //
// ./src/components/themed-html-components/Tooltip.jsx